import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';

function getSearchTags() {
  return ecosystemClient.getSearchTags();
}

export const GET_SEARCH_TAGS = registerQuery({
  fieldName: 'searchTags',
  fetcher: getSearchTags
});